export default __webpack_public_path__ + "static/19-723cf14382698d52f3120331aa708fee.png";